import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Input as InputKitten } from '@ui-kitten/components';

import { InputProps } from './types';
import { InputErrors } from './InputErrors';
import { styles as commonStyles } from './styles';
import { withTranslation } from '../../locales/hoc';
import { Text } from '../Text';

export const Input = withTranslation(
	forwardRef<InputKitten, InputProps>((props, ref) => {
		const { t } = useTranslation();
		const {
			style,
			textStyle,
			gutter,
			fullWidth,
			status = 'basic',
			error,
			errors,
			label,
			placeholder,
			optional,
			interactive = true,
			...inputProps
		} = props;

		const shouldSubmitOnEnterPress = Boolean(inputProps.onSubmitEditing);
		const labelText = label
			? label + (optional ? ` (${t('common.optional').toLowerCase()})` : '')
			: undefined;
		const statusColor = error ? 'danger' : (status as 'basic' | 'danger');

		return (
			<InputKitten
				style={[
					commonStyles.root,
					gutter && commonStyles.gutter,
					fullWidth && commonStyles.fullWidth,
					style,
					!interactive && statusColor in commonStyles && commonStyles[statusColor],
				]}
				textStyle={[commonStyles.textStyle, textStyle]}
				blurOnSubmit={shouldSubmitOnEnterPress}
				status={statusColor}
				caption={<InputErrors errors={errors} />}
				label={
					interactive
						? labelText
						: () => (
								<Text category="c1" style={commonStyles.label}>
									{labelText}
								</Text>
							)
				}
				placeholder={
					placeholder ? `${placeholder}${optional ? ` (${t('common.optional')})` : ''}` : undefined
				}
				caretHidden={!interactive}
				disabled={!interactive}
				{...inputProps}
				ref={ref}
			/>
		);
	}),
);
